import getCmsPage from 'services/api/cms'
import makeActionCreator from 'services/utility/makeActionCreator'
import { getPageDetails, convert, compare } from 'services/utility/cms'
import history from 'services/utility/common/history'
import getProfile from '../../app-state/profile/actions/getProfile'
import profileReducer from '../../app-state/profile/reducer'

export const CMS_API_FETCHING = 'CMS_API_FETCHING'
export const CMS_API_SUCCESS = 'CMS_API_SUCCESS'
export const CMS_API_FAILURE = 'CMS_API_FAILURE'
export const CMS_API_FILE_NOT_FOUND = 'CMS_API_FILE_NOT_FOUND'

export const cmsAPIFetching = makeActionCreator(CMS_API_FETCHING, 'data')
export const cmsAPISuccess = makeActionCreator(CMS_API_SUCCESS, 'data')
export const cmsAPIFailure = makeActionCreator(CMS_API_FAILURE, 'data')
export const cmsAPIFileNotFound = makeActionCreator(
  CMS_API_FILE_NOT_FOUND,
  'data',
)

export const loadCms = () => async (dispatch, getState) => {
  const param = window.location.pathname === '/baby-club' ? { view_id: '2', requestorigin: 'btc' } : {}
  const profileRes = await dispatch(getProfile({ ...param, full: 'Y' }))
  const { profile: { segment_ids } } = getState()
  dispatch(cmsAPIFetching())
  const { pageToBeFetched, pageIdToBeFetched } = getPageDetails()
  return getCmsPage(pageToBeFetched, pageIdToBeFetched, segment_ids).then(async (response) => {
    if (response.status === 200) {
      const moduleArray = response.data.modules
      if (!moduleArray.length) {
        dispatch(cmsAPIFileNotFound({ isFetching: false }))
        history.push('/404')
      } else {
        moduleArray.sort(compare)
        const json = convert(moduleArray)
        dispatch(cmsAPISuccess(json))
      }
    } else {
      // Error Handling in services/api
      dispatch(cmsAPIFailure({ isFetching: false }))
    }
  }).catch(() => {
    // Network Error
    dispatch(cmsAPIFailure({ isFetching: false }))
    history.push('/back-soon')
  })
}



// WEBPACK FOOTER //
// ./services/cms-state/actions/index.js